$('.collapsable.navigation-list.mgnl-navigation.with-icon').each(function(_, element){
    $(element).removeClass('toggle-on');
});

$('.navigation').each(function(_, element){
    var nav = $(element);
    var collapsables = nav.find('.collapsable');

    nav.find('.collapsable-trigger.js-trigger').on('click', function(e) {
        collapsables.not($(e.currentTarget).closest('.collapsable')).removeClass('toggle-on');
    });

    nav.find('.navigation-column').on('mouseover', function(e) {
        if (window.innerWidth > 1019) {
            $(e.currentTarget).find('.collapsable').not($(e.currentTarget).closest('.collapsable')).addClass('toggle-on');
        }
    });

    nav.find('.navigation-column').on('mouseout', function(e) {
        if (window.innerWidth > 1019) {
            $(e.currentTarget).find('.collapsable').not($(e.currentTarget).closest('.collapsable')).removeClass('toggle-on');
        }
    });
});
